module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_nordland_neg.dac797dc.svg";